import React, { FC } from "react";
import {
  Box,
  Button,
  Chip,
  Divider,
  ListItem,
  ListItemText,
  ThemeProvider,
  Typography,
  createTheme,
} from "@mui/material";
import { Item } from "../../Helpers/typings";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import MoreVertRoundedIcon from "@mui/icons-material/MoreVertRounded";

const theme = createTheme({
  components: {
    MuiListItemText: {
      styleOverrides: {
        root: {
          fontSize: 20,
        },
      },
    },
  },
});

export type Props = {
  item: Item;
  index: number;
  onRowClickForOpenDialog: (value: boolean) => void;
  onMoreClick: (event: React.MouseEvent<HTMLButtonElement>, item: Item) => void;
};

const TeamMembersDraggableListItem: FC<Props> = ({
  item,
  onRowClickForOpenDialog,
  onMoreClick,
}) => {
  return (
    <ThemeProvider theme={theme}>
      <ListItem
        sx={{
          paddingLeft: 2,
          paddingRight: 2,
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Box>
          <Typography>{item.teamMemberName}</Typography>
          <Typography>{item.teamMemberRole}</Typography>
          <Typography>{item.qualificationName}</Typography>
        </Box>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          {/* ✅ SHOW ANESTHETIST BADGE */}
          {item.isAnesthetist && (
            <Chip
              label="Anesthetist"
              size="small"
              color="primary"
              sx={{ fontSize: "11px" }}
            />
          )}

          {/* MORE ACTIONS */}
          <Button
            size="small"
            sx={{ minWidth: "30px" }}
            onClick={(e) => {
              e.stopPropagation();
              onMoreClick(e, item);
            }}
          >
            <MoreVertRoundedIcon sx={{ fill: "rgb(0 0 0 / 54%)" }} />
          </Button>
        </Box>
      </ListItem>
      <Divider />
    </ThemeProvider>
  );
};

export default TeamMembersDraggableListItem;
